
import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import {RushBufferDocument} from "@/models/buffer.model";
import RichTextEditor from "@/components/shared/RichTextEditor/RichTextEditor.vue";
import {updateRush} from "@/axios/repository/buffer.axios";
@Component({
  components: {RichTextEditor}
})
export default class SbEditRushDialog extends Vue {
  // Les props
  @PropSync('show') private isVisible!: boolean
  @Prop()private rush!: RushBufferDocument | null

  // Les propriétés
  private isValid: boolean = false
  private rushname: string = ''
  private rushdesc: string = ''
  private rulesname = [(v:string) => !!v && v.length > 3 || 'Name must have at least 3 characters']

  // Les propriétés calculées
  // Les hooks
  // Les méthodes surveillées
  @Watch('isVisible')
  private onVisible() {
    if (this.isVisible && this.rush) {
      this.rushname = this.rush.name
      this.rushdesc = this.rush.description
    } else {
      this.rushname = ''
      this.rushdesc = ''
    }
  }
  // Les méthodes d'instance
  private async onSave() {
    if (this.rush) {
      await updateRush(this.rush._id, this.rushname, this.rushdesc)
      this.$emit('updated')
      this.isVisible = false
    }
  }

  // Les méthodes statiques
}
